/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_01_Detail_Amateur_2_HeadingInputs */

const en_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where the method diverges`)
};

const es_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dónde el método se aparta`)
};

const de_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo die Methode divergiert`)
};

const zh_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这套方法的不同之处`)
};

const ar_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أين يختلف الأسلوب`)
};

const fr_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Là où la méthode diverge`)
};

const vi_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nơi phương pháp khác biệt`)
};

const sw_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahali mbinu hii inapotofautiana`)
};

const th_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จุดที่วิธีนี้แตกต่าง`)
};

const bs_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gdje se metoda razilazi`)
};

const ja_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このメソッドが一線を画す点`)
};

const ko_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 메서드가 달라지는 지점`)
};

const pt_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde o método se diferencia`)
};

const it_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove il metodo cambia strada`)
};

const sv_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Där metoden går sin egen väg`)
};

const nl_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar de methode afwijkt`)
};

const da_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvor metoden går sine egne veje`)
};

const nb_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der metoden går sin egen vei`)
};

const fi_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missä menetelmä erottuu`)
};

const pl_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gdzie metoda idzie własną drogą`)
};

const ru_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Где метод идёт своим путём`)
};

const tr_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yöntemin ayrıştığı nokta`)
};

const hi_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह विधि कहाँ अलग होती है`)
};

const id_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di mana metode ini berbeda`)
};

const ms_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di mana kaedah ini berbeza`)
};

const cs_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kde se metoda odlišuje`)
};

const el_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πού διαφοροποιείται η μέθοδος`)
};

const he_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`היכן השיטה נפרדת מהמקובל`)
};

const af_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar die metode afwyk`)
};

const hu_method_content_step_01_detail_amateur_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahol a módszer más utat jár`)
};

/**
* | output |
* | --- |
* | "Where the method diverges" |
*
* @param {Method_Content_Step_01_Detail_Amateur_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_01_detail_amateur_2_heading = /** @type {((inputs?: Method_Content_Step_01_Detail_Amateur_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_01_Detail_Amateur_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "de") return de_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "zh") return zh_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "ar") return ar_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "fr") return fr_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "vi") return vi_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "sw") return sw_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "th") return th_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "bs") return bs_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "ja") return ja_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "ko") return ko_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "pt") return pt_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "it") return it_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "sv") return sv_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "nl") return nl_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "da") return da_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "nb") return nb_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "fi") return fi_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "pl") return pl_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "ru") return ru_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "tr") return tr_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "hi") return hi_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "id") return id_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "ms") return ms_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "cs") return cs_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "el") return el_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "he") return he_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "af") return af_method_content_step_01_detail_amateur_2_heading(inputs)
	if (locale === "hu") return hu_method_content_step_01_detail_amateur_2_heading(inputs)
	return en_method_content_step_01_detail_amateur_2_heading(inputs)
});